module.exports = __webpack_public_path__ + "assets/img/honor2.273ae921.png";